import ServiceError from "./ServiceError"

import ApiClient from "./ApiClient"
import DataCache from "./DataCache"

const resultCache = new DataCache(3);

const getApiClient = () =>
  new ApiClient("content", `${process.env.PERSONALISATION_HOST}/api/content/`)

/*
{
  "stories": [
    {
      "visited": false,
      "cdnStory": {
        "uid": "11009175",
        "name": "Ernährung",
        "type": "content",
        "slug": "ernaehrung",
        "full_slug": "/v/ernaehrung/-/id-11009175",
        "access": {
          "type": "logged_in_show"
        },
        "metadata": {
          "description": "Wissenswertes rund um eine gesunde und bewusste Lebensweise für Profifußballer &#9917; Ernährung für Fußballer &#9917; DFB-Akademie",
          "title": "Ernährung",
          "ogimage": {
            "src": "https://assets.dfb.de/uploads/000/214/606/original_GettyImages-1054053878.jpg?1574078487",
          }
        },
        "content": {
          "component": "content_page",
          "title": "Ernährung",
          "subtitle": null,
          "card_callout": null,
          "tags": [
            "TESTKEYWORD2020"
          ],
          "root_categories": [
            {
              "uid": "621",
              "title": "Medizin & Athletik"
            }
          ]
        }
      }
    }
  ]
}
*/

/**
 * Return the array of "cdnStory" objects from the "stories" array.
 * The "visited" property is lost by this mapping.
 */
const storiesArrayMapper = data => {
  if (!Array.isArray(data.stories)) {
    console.error("Unexpected content response", data)
    throw new ServiceError(
      ServiceError.STATUS_INVALID_DATA,
      "Content service got unexpected data"
    )
  }
  return data.stories.map(story => story.cdnStory);
}

export async function getMostVisitedPagesByTag() {
  return getApiClient().get("page/mostVisitedPagesByTag", storiesArrayMapper)
}

/*
{
  "loggedIn": false,
  "mostVisited": {
    "stories": [...]
  },
  "mostRecentNewsAndColumn": {
    "stories": [...]
  }
  "mostVisitedByCategory": {
    "stories": [...]
  },
  "mostVisitedByTag": {
    "stories": [...]
  }
}
*/

/**
 * Returns the arrays of "cdnStory" objects from the "stories" arrays under the root keys values
 * and has a loggedIn flag to indicate personalized content
 */
const combinedStoriesMapper = data => {
  if (
    !data.mostRecentNewsAndColumn ||
    !data.mostVisited ||
    !data.mostVisitedByCategory ||
    !data.mostVisitedByTag
  ) {
    console.error("Unexpected combined content response", data)
    throw new ServiceError(
      ServiceError.STATUS_INVALID_DATA,
      "Content service got unexpected data"
    )
  }
  return {
    loggedIn: !!data.loggedIn,
    mostRecentNewsAndColumn: storiesArrayMapper(data.mostRecentNewsAndColumn),
    mostVisited: storiesArrayMapper(data.mostVisited),
    mostVisitedByCategory: storiesArrayMapper(data.mostVisitedByCategory),
    mostVisitedByTag: storiesArrayMapper(data.mostVisitedByTag),
  }
}

export async function getMostVisitedCombined() {
  return getApiClient().get("page/mostVisitedCombined", combinedStoriesMapper)
}

export function getMostVisitedCombinedCached() {
  return resultCache.getOrLoad("mostVisitedCombined", () => {
    return getMostVisitedCombined();
  })
}
